import { configureStore } from "@reduxjs/toolkit";
import successAlertSlice from "./successAlertSlice";
import infoSlice from "./infoAlertSlice";
import themeSlice from "./themeSlice";
import numberSlice from "./numberSlice";



const store = configureStore({
  reducer:{
    successAlert: successAlertSlice,
    infoAlert: infoSlice,
    themeSlice:themeSlice,
    numberSlice: numberSlice
  }
})


export default store;
